import { useNavigate } from "react-router-dom";

function HeaderB() {
  const navigate = useNavigate();

  const handleClick = (event, path) => {
    event.preventDefault();
    navigate(path);
  };
  return (
    <div id="Header_wrapper" className="bg-parallax" data-enllax-ratio="0.3">
      <header id="Header">
        <div className="header_placeholder" />
        <div id="Top_bar">
          <div className="container">
            <div className="column one">
              <div className="top_bar_left clearfix">
                <div className="logo">
                  <a
                    id="logo"
                    title="App Makelaar"
                    href="/"
                    onClick={(e) => {
                      handleClick(e, "/");
                      window.location.reload();
                    }}
                  >
                    <img
                      className="logo-main scale-with-grid"
                      src="content/architect2/images/architect2.png"
                    />
                    <img
                      className="logo-sticky scale-with-grid"
                      src="content/architect2/images/architect2.png"
                    />
                    <img
                      className="logo-mobile scale-with-grid"
                      src="content/architect2/images/architect2.png"
                    />
                  </a>
                </div>
                <div className="menu_wrapper">
                  <nav id="menu" className="menu-main-menu-container">
                    <ul id="menu-main-menu" className="menu">
                      <li>
                        <a
                          href="/"
                          onClick={(e) => {
                            handleClick(e, "/");
                            window.location.reload();
                          }}
                        >
                          <span>Home</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/about"
                          onClick={(e) => handleClick(e, "/about")}
                        >
                          <span>Over ons</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/info"
                          onClick={(e) => handleClick(e, "/info")}
                        >
                          <span>IT Oplossingen</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <a className="responsive-menu-toggle" href="#">
                    <i className="icon-menu" />
                  </a>
                </div>
                <div className="secondary_menu_wrapper" />
                <div className="banner_wrapper" />
                <div className="search_wrapper">
                  <form method="get">
                    <i className="icon_search icon-search" />
                    <a href="#" className="icon_close">
                      <i className="icon-cancel" />
                    </a>
                    <input
                      type="text"
                      className="field"
                      name="s"
                      id="s"
                      placeholder="Enter your search"
                    />
                    <input
                      type="submit"
                      className="submit"
                      defaultValue=""
                      style={{ display: "none" }}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
export default HeaderB;
